// REMOVE SPACE IN ANY POSITIONS OF A STRING
const noSpaceUTL = (string) => string.replace(/\s/g, '');

export default noSpaceUTL;
